import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

type ResetPasswordRequest = {
  email: string;
  password: string;
  new_password: string;
  new_password_confirmation: string;
};
type ResetPasswordResponse = unknown;
type ResetPasswordErrorResponse = {
  email?: string[];
  password?: string[];
  new_password?: string[];
  new_password_confirmation?: string[];
  message?: string[];
};

export const companyFirstResetPasswordApiClient = {
  resetPassword: async (
    params: ResetPasswordRequest,
  ): Promise<ApiResult<ResetPasswordResponse, ResetPasswordErrorResponse>> => {
    return await axiosClient.put('/company/auth/first-reset-password', params);
  },
};
